import { FormTypes } from 'models'

export const transformFormType = (formType: FormTypes): string => {
  switch (formType) {
    case FormTypes.Inform:
      return 'Информационное партнерство'
    case FormTypes.Sponsor:
      return 'Рекламные возможности'
    default:
      return ''
  }
}
